/** @flow */
import { combineReducers, type Reducer } from "redux";
import staffGroups from "./staff-groups";
import systemAccess from "./system-access";
import { pages } from "./pages";
import serviceSettings from "./service-settings";
import nurseDeclinedReasons from "./nurse-declined-reasons";
import emailControls from "./email-controls";
import dataSecurity from "./data-security";
import wellbeingServices from "./wellbeing-services";
import absenceReasons from "./absence-reasons";
import alerts from "./alerts";
import specialContacts from "./special-contacts";
import specialContactsTypes from "./special-contacts-types";
import userPermissions from "./user-permissions";
import shiftPatterns from "./shift-patterns";
import reportingParameters from "./reporting-parameters";
import employeeIdentity from "./employee-identity";
import standardQuestions from "./standard-questions";
import dynamicQuestions from "./dynamic-questions";
import emailNotifications from "./email-notifications";
import managerSmsNotifications from "./manager-sms-notifications";
import employeeSmsNotifications from "./employee-sms-notifications";
import defaultStandardScripts from "./default-standard-scripts";
import referrals from "./referrals";
import rtw from "./rtw";
import absenceMonitoring from "./absence-monitoring";
import userAccounts from "./user-accounts";
import appAdoption from "./app-adoption";
import managerSelfService from "./manager-self-service";
import auditLogs from "./audit-logs";

import { pagesInitialState } from "./pages/state";
import { initialState as nurseDeclinedReasonsState } from "./nurse-declined-reasons/state";
import { initialState as staffGroupsInitialState } from "./staff-groups/state";
import { initialState as systemAccessInitialState } from "./system-access/state";
import { initialState as serviceSettingsInitialState } from "./service-settings/state";
import { initialState as emailControlsInitialState } from "./email-controls/state";
import { initialState as dataSecurityInitialState } from "./data-security/state";
import { initialState as wellbeingServicesInitialState } from "./wellbeing-services/state";
import { initialState as absenceReasonsInitialState } from "./absence-reasons/state";
import { initialState as alertsInitialState } from "./alerts/state";
import { initialState as specialContactsInitialState } from "./special-contacts/state";
import { initialState as specialContactsTypesInitialState } from "./special-contacts-types/state";
import { initialState as userPermissionsInitialState } from "./user-permissions/state";
import { initialState as shiftPatternsInitialState } from "./shift-patterns/state";
import { initialState as reportingParametersState } from "./reporting-parameters/state";
import { initialState as employeeIdentityState } from "./employee-identity/state";
import { initialState as dynamicQuestionsState } from "./dynamic-questions/state";
import { initialState as emailNotificationsState } from "./email-notifications/state";
import { initialState as standardQuestionsState } from "./standard-questions/state";
import { initialState as managerSmsNotificationsState } from "./manager-sms-notifications/state";
import { initialState as employeeSmsNotificationsState } from "./employee-sms-notifications/state";
import { initialState as defaultStandardScriptsState } from "./default-standard-scripts/state";
import { initialState as referralsInitialState } from "./referrals/state";
import { initialState as rtwInitialState } from "./rtw/state";
import { initialState as absenceMonitoringInitialState } from "./absence-monitoring/state";
import { initialState as userAccountsState } from "./user-accounts/state";
import { initialState as appAdoptionState } from "./app-adoption/state";
import { initialState as managerSelfServiceState } from "./manager-self-service/state";
import { initialState as auditLogsState } from "./audit-logs/state";

import type { ServiceState } from "./types";

export const initialState = {
  pagesState: pagesInitialState,
  serviceSettings: serviceSettingsInitialState,
  nurseDeclinedReasons: nurseDeclinedReasonsState,
  staffGroups: staffGroupsInitialState,
  systemAccess: systemAccessInitialState,
  emailControls: emailControlsInitialState,
  dataSecurity: dataSecurityInitialState,
  wellbeingServices: wellbeingServicesInitialState,
  absenceReasons: absenceReasonsInitialState,
  alerts: alertsInitialState,
  specialContacts: specialContactsInitialState,
  specialContactsTypes: specialContactsTypesInitialState,
  userPermissions: userPermissionsInitialState,
  shiftPatterns: shiftPatternsInitialState,
  reportingParameters: reportingParametersState,
  employeeIdentity: employeeIdentityState,
  standardQuestions: standardQuestionsState,
  dynamicQuestions: dynamicQuestionsState,
  emailNotifications: emailNotificationsState,
  managerSmsNotifications: managerSmsNotificationsState,
  employeeSmsNotifications: employeeSmsNotificationsState,
  defaultStandardScripts: defaultStandardScriptsState,
  referrals: referralsInitialState,
  rtw: rtwInitialState,
  absenceMonitoring: absenceMonitoringInitialState,
  userAccounts: userAccountsState,
  appAdoption: appAdoptionState,
  managerSelfService: managerSelfServiceState,
  auditLogs: auditLogsState,
};

export default (combineReducers({
  pages,
  serviceSettings,
  nurseDeclinedReasons,
  staffGroups,
  systemAccess,
  emailControls,
  dataSecurity,
  wellbeingServices,
  absenceReasons,
  alerts,
  specialContacts,
  specialContactsTypes,
  userPermissions,
  shiftPatterns,
  reportingParameters,
  employeeIdentity,
  standardQuestions,
  dynamicQuestions,
  emailNotifications,
  managerSmsNotifications,
  employeeSmsNotifications,
  defaultStandardScripts,
  referrals,
  rtw,
  absenceMonitoring,
  userAccounts,
  appAdoption,
  managerSelfService,
  auditLogs,
}): Reducer<ServiceState, *>);
